function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { hash } from '../hash';
var _callbacks = /*#__PURE__*/new WeakMap();
var _ManifestChangeDetection_brand = /*#__PURE__*/new WeakSet();
export class ManifestChangeDetection {
  constructor(events) {
    this.events = events;
    _classPrivateMethodInitSpec(this, _ManifestChangeDetection_brand);
    _classPrivateFieldInitSpec(this, _callbacks, new Map());
    _assertClassBrand(_ManifestChangeDetection_brand, this, _initEvents).call(this);
  }
  triggerManifestChange(manifestContextId) {
    _assertClassBrand(_ManifestChangeDetection_brand, this, _notify).call(this, manifestContextId);
  }
  onChange(manifestContextId, cb) {
    const id = `ch-${hash()}`;
    _classPrivateFieldGet(_callbacks, this).set(id, {
      manifestContextId,
      cb
    });
    return () => {
      _classPrivateFieldGet(_callbacks, this).delete(id);
    };
  }
}
function _initEvents() {
  this.events.subscribe(event => {
    if (event.type === 'HostEvent' && event.payload.type === 'componentSelectionChanged') {
      _assertClassBrand(_ManifestChangeDetection_brand, this, _notify).call(this);
    }
  });
}
function _notify(manifestContextId) {
  _classPrivateFieldGet(_callbacks, this).forEach(consumer => {
    if (!manifestContextId || consumer.manifestContextId === manifestContextId) {
      const wrappedCb = async () => {
        consumer.cb();
      };
      wrappedCb().catch(e => console.warn(e));
    }
  });
}
//# sourceMappingURL=ManifestChangeDetection.js.map